import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';
import { PreferredPartnerModule } from '../preferred-partner/preferred-partner.module';
import { LoadApprovalModule } from '../shared/load-approval-dialog/load-approval.module';
import { SharedModule } from '../shared/shared.module';
import { CalendarDayDetailsComponent } from './calendar-day-details/calendar-day-details.component';
import { CalendarEventsDialogComponent } from './calendar-events-dialog/calendar-events-dialog.component';
import { DriverHitchCalendarComponent } from './calendar/driver-hitch-calendar.component';
import { DriverDemandMapComponent } from './driver-demand-map/driver-demand-map.component';
import { DriverInformationComponent } from './driver-information/driver-information.component';
import { FracActivityInfoComponent } from './frac-activity-info/frac-activity-info.component';
import { OwnerDashboardMainComponent } from './main/owner-dashboard-main.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { NewsFeedComponent } from './news-feed/news-feed.component';
import { OwnerDashboardRoutingModule } from './owner-dashboard-routing.module';
import { MigrationMapComponent } from './owner-dashboard/migration-map/migration-map.component';
import { OwnerDashboardComponent } from './owner-dashboard/owner-dashboard.component';
import { ToursAssetChartComponent } from './owner-dashboard/tours-asset-chart/tours-asset-chart.component';
import { RequestDriverTransferComponent } from './request-driver-transfer/request-driver-transfer.component';

@NgModule({
  declarations: [
    OwnerDashboardMainComponent,
    FracActivityInfoComponent,
    DriverDemandMapComponent,
    RequestDriverTransferComponent,
    DriverHitchCalendarComponent,
    CalendarDayDetailsComponent,
    CalendarEventsDialogComponent,
    OwnerDashboardComponent,
    MigrationMapComponent,
    NavBarComponent,
    DriverInformationComponent,
    NewsFeedComponent,
    ToursAssetChartComponent,
  ],
  imports: [
    CommonModule,
    OwnerDashboardRoutingModule,
    SharedModule,
    MaterialModule,
    ReactiveFormsModule,
    LoadApprovalModule,
    PreferredPartnerModule,
  ],
  exports: [NavBarComponent, MigrationMapComponent, NewsFeedComponent],
})
export class OwnerDashboardModule {}
